import {VGNav} from "vgnav";
import {onReady} from "../../../../modules/vegas/js/util";
import VGFlipList from "./nav/VGFlipList";

function init() {
	[...document.querySelectorAll('.vg-nav')].forEach((el) => {
		new VGNav(el, {
			breakpoint: 'sm',
			isHover: true,
			isCollapse: true,
			isExpand: true,
			isHamburger: true,
			toggle: ''
		}, {
			afterInit: function () {
				setFlipEffect();
			}
		});
	});
}

function setFlipEffect() {
	const $elmSidebar = document.getElementById('vg-nav-sidebar');
	if ($elmSidebar) {
		let $_navigation = $elmSidebar.querySelector('.vg-nav-wrapper');
		if ($_navigation) {
			let arrSimple = [...$_navigation.querySelectorAll('.dropdown > a')],
				arrMega = [...$_navigation.querySelectorAll('.dropdown-mega > a')];

			$_navigation.classList.remove('vg-nav-wrapper');

			new VGFlipList($_navigation, {target: arrSimple.concat(arrMega)});
		}
	}
}

onReady(init);
typeof onTurboRender !== 'undefined' && onTurboRender(init);
